import React from 'react';
import { withTranslation } from 'react-i18next';
import './BlockBike.scss';
import Modal from 'react-modal';
import salarySacrificeTable from '../../mock/salarySacrificeCarrefour';

class BlockBike extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: false
        }
        Modal.setAppElement('#SampleBikeApp');

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    minNetImpact = () => {
        const lines = salarySacrificeTable.filter(line => line[1] < this.props.price);
        return lines[lines.length - 1][3] ? lines[lines.length - 1][3] : 'XXX';
    } 

    maxNetImpact = () => {
        const lines = salarySacrificeTable.filter(line => line[1] > this.props.price);
        return lines[0][3] ? lines[0][3] : 'YYY';
    };
    
    showModal = () => this.setState({ show: true });
    
    hideModal = () => this.setState({ show: false });

    formatedPrice() {
        return new Intl.NumberFormat(this.props.i18n.language + '-' + this.props.i18n.language.toUpperCase(), { style: 'currency', currency: 'EUR' }).format(Math.trunc(this.props.price));
    }

    render() {
        return (
            <div className="BlockBike">
                <img src={this.props.image} alt={this.props.image} />
                <p className='bikeBrand'>{this.props.brand}</p>
                <h3 className='bikeName'>{this.props.name}</h3>
                <div className='sameLine'>
                    <p className='bikeType'>{this.props.type}</p>
                    <p className='bikePrice'>{this.formatedPrice()}</p>
                </div>
                <div className='linksLine'>
                    <a className='linkBikeView' href={this.props.link} target="_blank" rel="noreferrer">{this.props.t('SampleBikePageBikeBlockBikeSee')}</a>
                    <p className='linkNetImpact' onClick={() => this.showModal()}>{this.props.t('SampleBikePageBikeBlockBikeNetImpactTitle')}</p>
                    {/* eslint-disable-next-line */}
                    <a className='linkFindUshop' onClick={() => this.props.displayRightPage(this.props.brand)}>{this.props.t('SampleBikePageBikeBlockBikeFoundShop')}</a>
                </div>

                <Modal
                    isOpen={this.state.show}
                    style={{content: {
                        top: '25%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        maxWidth: '45rem',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                      }}}
                    contentLabel="Net Impact Modal"
                >
                    <h2>{this.props.t('SampleBikePageBikeBlockBikeNetImpactTitle')}</h2>
                    <div>
                        <p>{this.props.t('SampleBikePageBikeBlockBikeNetImpactDescription')}</p>
                        <p>{this.props.t('SampleBikePageBikeBlockBikeNetImpactEstimation')}{this.minNetImpact()}€ {this.props.t('SampleBikePageBikeBlockBikeNetImpactEstimation1')} {this.maxNetImpact()}€</p>
                    </div>
                    <p
                        style={{color: '#A9C21D', cursor: 'pointer'}}
                        onClick={() => this.hideModal()}
                    >
                        {this.props.t('SampleBikePageBikeBlockBikeNetImpactClose')}
                    </p>
                </Modal>
            </div>
        );
    }
}

export default withTranslation()(BlockBike);